import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui'

/**
 * Tela graciosa para erros de renderização de rota (defaultErrorComponent do TanStack Router). Evita
 * a "tela branca": mostra uma mensagem neutra + tentar de novo (reset) e voltar ao início. Nunca expõe
 * a stack/detalhe técnico ao usuário.
 */
export function AppErrorPage({ reset }: { readonly error: Error; readonly reset: () => void }) {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen items-center justify-center p-6">
      <div className="flex w-full max-w-md flex-col items-center gap-4 text-center">
        <span
          aria-hidden="true"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-status-danger-subtle text-status-danger"
        >
          <AlertTriangle className="h-6 w-6" />
        </span>
        <div className="flex flex-col gap-1">
          <h1 className="text-lg font-semibold text-foreground-primary">{t('appError.title')}</h1>
          <p className="text-sm text-foreground-muted">{t('appError.description')}</p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-2">
          <Button onClick={reset}>{t('appError.retry')}</Button>
          <a
            href="/"
            className="inline-flex h-10 items-center justify-center rounded-md border border-border-default bg-background-elevated px-4 text-sm font-medium text-foreground-primary hover:bg-background-subtle"
          >
            {t('appError.home')}
          </a>
        </div>
      </div>
    </div>
  )
}
